import React from "react";
// Front Pages
import Home from "../pages/front/Home";

// Authentication Pages
import Authentication from "../pages/front/authentication/index";
import OtpVerification from "../pages/front/authentication/otpVerification";
import ResetPassword from "../pages/front/authentication/resetPassword";
import ForgotPassword from "../pages/front/authentication/forgotPassword";
import AdminLogin from "../pages/admin/signIn/AdminLogin";
import AdminForgotPassword from "../pages/auth/ForgotPassword";

// Admin Pages
import Testimonials from "../pages/admin/Testimonials";
import Category from "../pages/admin/Category";
import Post from "../pages/admin/Post/Post";
import Testing from "../pages/front/Testing";
import Dashboard from "../pages/admin/Dashboard";
import Profile from "../pages/user/profile/Profile";
import AdminList from "../pages/admin/admins/AdminList";
import userList from "../pages/admin/users/UserList";
import EmailTemplate from "../pages/admin/emailTemplate/EmailTemplate";
import Settings from "../pages/admin/siteSettings/Settings";
import PostDetails from "../pages/admin/Post/PostDetails";
import Comment from "../pages/admin/comment/Comment";
import Task from "../pages/admin/task/Task.js";
import TaskDetails from "../pages/admin/task/TaskDetails.js";
import Media from "../pages/admin/media/Media.js";
import Question from "../pages/admin/question/Question.js";

//Do Like that ADMIN USER others in small letter
// User Pages

// Example Data ===============>
//  {
//     key:"uniqueKey",
//     path: "/login",
//     routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//     component: component || React.lazy(() => import("../pages/auth/Login")),
//     layout: "auth"||"front"||"admin",
//     disabled:true||false,
//     title: "page title",
//     subRoute: [
//       {
//         key:"uniqueKey",
//         path: "manage",
//         routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//         component: component || React.lazy(() => import("../pages/employees/Manage")),
//         layout: "auth"||false,
//         disabled:true||false,
//         title: "page title",
//       },
//     ],
//  }

export const frontRoutes = (data) => {
  return [
    {
      path: "/",
      title: "Home",
      component: Home,
      routeType: false,
    },
    {
      path: "/testing",
      title: "Testing",
      component: Testing,
      layout: "admin",
      routeType: false,
    },
  ];
};

export const authRoutes = (data) => [
  {
    path: "/authentication",
    title: "Authentication",
    component: Authentication,
    routeType: "auth",
  },
  {
    path: "/otp-verification",
    title: "OTP Verification",
    component: OtpVerification,
    routeType: "auth",
  },
  {
    path: "/reset-password",
    title: "Reset Password",
    component: ResetPassword,
    routeType: "auth",
  },
  {
    path: "/forgot-password",
    title: "Forgot Password",
    component: ForgotPassword,
    routeType: "auth",
  },
  {
    path: "/admin/signin",
    title: "Admin Login",
    component: AdminLogin,
    routeType: "auth",
  },
  {
    path: "/admin/forgot-password",
    title: "Admin Forgot Password",
    component: AdminForgotPassword,
    routeType: "auth",
  },
];

export const adminRoutes = (data) => [
  {
    path: "/admin/dashboard",
    title: "dashboard",
    layout: "admin",
    routeType: "ADMIN",
    component: Dashboard,
  },
  {
    path: "/user/profile",
    title: "Profile",
    layout: "admin",
    routeType: "ADMIN",
    component: Profile,
  },
  {
    path: "/admins",
    title: "Admin List",
    layout: "admin",
    routeType: "ADMIN",
    component: AdminList,
  },
  {
    path: "/admin/users",
    title: "User List",
    layout: "admin",
    routeType: "ADMIN",
    component: userList,
  },
  {
    path: "/admin/questions",
    title: "questions",
    layout: "admin",
    routeType: "admin",
    component: Question,
  },
  {
    path: "/admin/email-template",
    title: "Email Template",
    layout: "admin",
    routeType: "ADMIN",
    component: EmailTemplate,
  },
  {
    path: "/admin/site-settings",
    title: "Profile",
    layout: "admin",
    routeType: "ADMIN",
    component: Settings,
  },
  {
    path: "/admin/categories",
    title: "categories",
    layout: "admin",
    routeType: "ADMIN",
    component: Category,
  },
  {
    path: "/admin/post",
    title: "post",
    layout: "admin",
    routeType: "ADMIN",
    component: Post,
  },
  {
    path: "/admin/post/details/:id",
    title: "post details",
    layout: "admin",
    routeType: "ADMIN",
    component: PostDetails,
  },
  {
    path: "/admin/comment",
    title: "comment",
    layout: "admin",
    routeType: "ADMIN",
    component: Comment,
  },
  {
    path: "/admin/task",
    title: "task",
    layout: "admin",
    routeType: "ADMIN",
    component: Task,
  },
  {
    path: "/admin/task/details/:id",
    title: "task details",
    layout: "admin",
    routeType: "ADMIN",
    component: TaskDetails,
  },
  {
    path: "/admin/media",
    title: "media",
    layout: "admin",
    routeType: "ADMIN",
    component: Media,
  },

  // {
  //   path: "/admin/tetimonials",
  //   title: "tetimonials",
  //   layout: "admin",
  //   routeType: "admin",
  //   component: Testimonials,
  // },
  // {
  //   path: "/admin/:categoryType/categories",
  //   title: "categories",
  //   layout: "admin",
  //   routeType: "admin",
  //   component: Category,
  // },
];

export const userRoutes = (data) => [];

export const routerData = (data) => {
  return [...userRoutes(data), ...adminRoutes(data), ...authRoutes(data), ...frontRoutes(data)];
};
